import React, { useEffect } from 'react';
import Ripple from './../Ripple';
import Span from './../Span';
import { Icon, Popover, Menu, Tooltip } from 'antd';
import i18n from './../../../../../constants/initLng';
import { getPathWithParams, formatValidation } from '../../../../../helpers/functions';
import history from './../../../../../helpers/history';
import Wrapper from '../Wrapper';
import Dropdown from '../Dropdown';
import Modal from '../Modal';
import Images from '../../../../../constants/Images';
import './styles.less';
import { TRANSLATE_LANGUAGE } from '../../../../../constants/Define';
import { findIndex, find, toArray, orderBy } from 'lodash';

export const FlagIcons = (props) => {
    const languages = orderBy(props.languages || [], ['isDefault', 'languageCode'], ['desc', 'asc']);
    return (
        <Tooltip title={props.hideDefault && `${(props.languages || []).length - 1} ${i18n.t(`translate.translatedLanguages`).toLowerCase()}`}
            placement={props.tooltipPlacement}>
            <Wrapper className={`hms-flag-icons ${props.className || ''}`}>
                {languages.map(lang => !(lang.isDefault && props.hideDefault) && lang.languageCode && (
                    <Tooltip key={lang.languageCode} title={`${i18n.t(`translate.languages.${lang.languageCode?.split('-')?.[0] || lang.languageCode}`)}${lang.isDefault ? ` (${i18n.t(`translate.defaultLanguage`)})` : ''}`} placement="bottom">
                        <img alt={lang.name} src={Images.flag.square[lang.languageCode?.split('-')?.[0] || lang.languageCode]}
                            className={`flag-icon-16px ${lang.isDefault && languages.length > 1 ? 'flag-icon-default-lang' : ''}`}
                            style={{ width: props.size || 16, height: props.size || 16 }}
                        />
                    </Tooltip>
                ))}
            </Wrapper>
        </Tooltip>
    )
}

const TranslateButton = (props) => {
    const { disabledActionRemove = false } = props;
    const DEFAULT_LANG = find(props.languages || [], item => !!item.isDefault);

    useEffect(() => {
        // set default lang to vi-VN only when defaultSelecting is true
        if(props.defaultSelecting && !props.current){
            setTimeout(() => {
                onClick({key: TRANSLATE_LANGUAGE.VN.id});
            }, 100);
        }
    }, [props.defaultSelecting, props.current]);
    
    const onClick = (e) => {
        if (props.defaultSelecting) {
            const lang = find(toArray(TRANSLATE_LANGUAGE), item => item.id === e.key);
            return lang && props.onSelectDefault && props.onSelectDefault(lang)
        } else if (props.onChange) {
            const lang = find(toArray(TRANSLATE_LANGUAGE), item => item.id === e.key);
            if (DEFAULT_LANG && lang && lang.code === DEFAULT_LANG.languageCode) {
                return props.onClear && props.onClear();
            } else if (lang) {
                lang.included = isIncludedLanguage(lang);
                return props.onChange(lang)
            }
        }
    }
    const removeLang = (lang) => {
        if (props.defaultSelecting) {
            return lang && props.onSelectDefault && props.onSelectDefault([])
        }
        return props.onRemove && props.onRemove(lang);
    }
    const onRemove = (e, lang) => {
        e.stopPropagation();
        const { confirm } = Modal;
        confirm({
            title: formatValidation(i18n.t('validation.statusCode.code.7'), i18n.t(`translate.title`)),
            content: i18n.t(`translate.languages.${lang.id}`),
            okText: i18n.t(`action.remove`),
            cancelText: i18n.t(`action.cancel`),
            onOk: () => removeLang(lang),
        });
    };
    const isIncludedLanguage = (langEnum) => {
        return findIndex(props.languages || [], item => item.languageCode?.split('-')?.[0] === langEnum.id) !== -1;
    }
    const tooltipTitle = props.validation && props.validation.messageError;
    return (
        <Dropdown overlay={
            <Menu onClick={onClick}>
                {Object.keys(TRANSLATE_LANGUAGE).map(lang => (
                    <Menu.Item key={TRANSLATE_LANGUAGE[lang].id} disabled={TRANSLATE_LANGUAGE[lang].code === props.current}>
                        <Tooltip title={DEFAULT_LANG && TRANSLATE_LANGUAGE[lang].code === DEFAULT_LANG.languageCode && i18n.t(`translate.defaultLanguage`)} placement="left">
                            <Wrapper className="w100-percent flex-center pt-1 pb-1 lang-item">
                                <img src={Images.flag.square[TRANSLATE_LANGUAGE[lang].id]} alt={i18n.t(`translate.languages.${TRANSLATE_LANGUAGE[lang].id}`)} className="flag-icon-16px mr-1" /> {i18n.t(`translate.languages.${TRANSLATE_LANGUAGE[lang].id}`)}
                                {isIncludedLanguage(TRANSLATE_LANGUAGE[lang]) && <Icon type="check" className={`ml-2 ${(!DEFAULT_LANG || TRANSLATE_LANGUAGE[lang].code !== DEFAULT_LANG.languageCode) ? 'icon-check' : ''}`} />}
                                {isIncludedLanguage(TRANSLATE_LANGUAGE[lang]) && !props.defaultSelecting && (!DEFAULT_LANG || TRANSLATE_LANGUAGE[lang].code !== DEFAULT_LANG.languageCode) && !disabledActionRemove &&
                                    <Tooltip title={`${i18n.t(`action.remove`)} ${i18n.t(`translate.language`).toLowerCase()}`}>
                                        <Icon type="delete" className="ml-2 btn-remove" onClick={(e) => onRemove(e, TRANSLATE_LANGUAGE[lang])} />
                                    </Tooltip>
                                }
                            </Wrapper>
                        </Tooltip>
                    </Menu.Item>
                ))}
            </Menu>
        }>
            <Tooltip title={tooltipTitle} placement="left" visible={!!tooltipTitle}>
                <Wrapper className={`hms-translate-button ant-btn-group flex-center ${props.validation ? 'border-red' : ''}`}>
                    <Ripple color="white" className="btn-language ant-btn btn-default flex-center" waitForEffect={true} onClick={onClick}>
                        <Icon type="global" className="mr-1" />{i18n.t(`${props.defaultSelecting ? 'translate.language' : 'action.translate'}`)}{props.defaultSelecting && <Span className="colorRed">*</Span>}
                    </Ripple>
                    {(props.current || (props.defaultSelecting && !!(props.languages || []).length)) &&
                        <Wrapper className={`ant-btn btn-default ant-btn-background-ghost flex-center ${(!DEFAULT_LANG || props.current !== DEFAULT_LANG.languageCode) ? 'btn-flag' : ''}`}>
                            <img src={Images.flag.square[props.current?.split('-')?.[0] || props.current]}
                                alt={i18n.t(`translate.languages.${props.current?.split('-')?.[0] || props.current}`)} className="flag-icon-16px" />
                            {(!DEFAULT_LANG || props.current !== DEFAULT_LANG.languageCode) &&
                                <Tooltip title={props.defaultSelecting ? i18n.t(`action.cancel`) : i18n.t(`action.exit`)}>
                                    <Ripple color="white" onClick={props.onClear} className="btn-remove">
                                        <Icon type="close" />
                                    </Ripple>
                                </Tooltip>
                            }
                        </Wrapper>
                    }
                </Wrapper >
            </Tooltip>
        </Dropdown>
    )
}

const SyncLanguageRatePlan = () => {
    alert("akjsaksj")
}

export const FlagIconsRatePlan= (props) => {
    const languagesOrderBy = orderBy(props.languages || [], ['isDefault', 'languageCode'], ['desc', 'asc']);
    const languages = [
        {
            languageCode: 'vi-VN',
            isDefault: true,
            name: 'Tieng Viet',
            isExisted: false
        },
        {
            languageCode: 'ko-KR',
            isDefault: false,
            name: 'Tieng Han',
            isExisted: false
        },
        {
            languageCode: 'zh-CN',
            isDefault: false,
            name: 'Tieng trung',
            isExisted: false
        },
        {
            languageCode: 'en-US',
            isDefault: false,
            name: 'Tieng anh',
            isExisted: false
        },
        {
            languageCode: 'ru-RU',
            isDefault: false,
            name: 'Tieng Nga',
            isExisted: false
        },
        {
            languageCode: 'hi-IN',
            isDefault: false,
            name: 'Tieng An',
            isExisted: false
        }
    ]
    languagesOrderBy.forEach(element => {
        const idx = languages.findIndex(x => x.languageCode === element.languageCode);
        if(idx > -1) {
            languages[idx] = element;
            languages[idx].isExisted = true;
        }
    });

    return (
        <Tooltip title={props.hideDefault && `${(props.languages || []).length - 1} ${i18n.t(`translate.translatedLanguages`).toLowerCase()}`}
            placement={props.tooltipPlacement}>
            <Wrapper className={`hms-flag-icons ${props.className || ''}`}>
                {languages.map(lang => !(lang.isDefault && props.hideDefault) && lang.languageCode && (
                    <Tooltip key={lang.languageCode} title={`${i18n.t(`translate.languages.${lang.languageCode?.split('-')?.[0] || lang.languageCode}`)}${lang.isDefault ? ` (${i18n.t(`translate.defaultLanguage`)})` : ''}`} placement="bottom">
                        <img alt={lang.name} src={Images.flag.square[lang.languageCode?.split('-')?.[0] || lang.languageCode]}
                            className={`flag-icon-16px ${lang.isDefault && languages.length > 1 ? 'flag-icon-default-lang' : ''}`}
                            style={{ width: props.size || 16, height: props.size || 16,  filter: lang.isExisted ? '' :'grayscale(100%)'}}
                        />
                    </Tooltip>
                ))}
            </Wrapper>
        </Tooltip>
    )
}
export default TranslateButton;
